import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fpc-preloader',
  templateUrl: './preloader.component.html',
  styleUrls: ['./preloader.component.scss']
})
export class PreloaderComponent implements OnInit {

  
  constructor() { }

  ngOnInit(): void {
  }

}
